<template>
  <section class="hero" :class="color">
    <div class="hero-body">
      <div class="container">
        <div class="columns">
          <div class="column is-four-fifths">
            <h1 class="title">
              {{ titleDisplay }}
            </h1>
            <h2 class="subtitle">
              {{ subtitleDisplay }}
            </h2>
          </div>
          <div class="column">
            <NewMatchButton
              v-if="isLoggedIn === true"/>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { EventBus } from '@/services/bus'
import AuthService from '@/services/authService'
import NewMatchButton from '@/components/NewMatchButton'
export default {
  components: {
    NewMatchButton
  },
  props: {
    color: {
      required: false,
      type: String,
      default: 'is-primary'
    },
    page: {
      required: false,
      type: String
    },
    title: {
      required: false,
      type: String
    },
    subtitle: {
      required: false,
      type: String
    }
  },
  data () {
    return {
      isLoggedIn: null,
      phraseCount: {
        feed: {
          title: 1,
          subtitle: 1
        },
        leaderboard: {
          title: 2,
          subtitle: 1
        },
        matchs: {
          title: 1,
          subtitle: 1
        },
        match: {
          title: 1,
          subtitle: 1
        },
        tournaments: {
          title: 1,
          subtitle: 2
        },
        home: {
          title: 1,
          subtitle: 1
        },
        rules: {
          title: 1,
          subtitle: 2
        },
        about: {
          title: 1,
          subtitle: 1
        },
        guild: {
          title: 1,
          subtitle: 1
        },
        logged: {
          title: 1,
          subtitle: 1
        }
      }
    }
  },
  computed: {
    titleDisplay () {
      if (!this.title) {
        return this.$t('banners.' + this.page + '.title.' + this.getRandomNumber(this.phraseCount[this.page].title))
      }
      return this.title
    },
    subtitleDisplay () {
      if (!this.subtitle) {
        return this.$t('banners.' + this.page + '.subtitle.' + this.getRandomNumber(this.phraseCount[this.page].subtitle))
      }
      return this.subtitle
    }
  },
  methods: {
    getRandomNumber (max) {
      return Math.floor(Math.random() * (max - 1 + 1)) + 1
    }
  },
  created () {
    this.isLoggedIn = AuthService.isLoggedIn()
    let vm = this
    EventBus.$on('isLoggedIn', function (isLoggedIn) {
      vm.isLoggedIn = isLoggedIn
    })
  }
}
</script>

<style scoped>
  .hero {
    margin-bottom: 15px;
  }
</style>



// WEBPACK FOOTER //
// src/components/HeroBanner.vue